import * as React from "react";
import type { SVGProps } from "react";
const SvgCutlery = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#cutlery_svg__a)">
      <path d="M19 22c-.55 0-1-.45-1-1v-5h-3c-.55 0-1-.45-1-1 0-3.15 0-8.41 4.29-12.71a1.002 1.002 0 0 1 1.71.7V21c0 .55-.45 1-1 1m-3-8h2V5.86c-1.73 2.81-1.96 5.87-2 8.14m-8 8c-.55 0-1-.45-1-1V10.87C5.28 10.43 4 8.86 4 7V3c0-.55.45-1 1-1s1 .45 1 1v4c0 1.1.9 2 2 2s2-.9 2-2V3c0-.55.45-1 1-1s1 .45 1 1v4c0 1.86-1.28 3.43-3 3.87V21c0 .55-.45 1-1 1" />
      <path d="M8 8c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1" />
    </g>
    <defs>
      <clipPath id="cutlery_svg__a">
        <path fill="#fff" d="M4 2h16v20H4z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCutlery;
